import { defineStore } from "pinia";

export const useConnectionStore = defineStore("ConnectionStore", () => {
  const started = ref(false);
  const online = ref<boolean>(navigator.onLine);

  const onlineHandler = () => {
    online.value = true;
  };
  const offlineHandler = () => {
    online.value = false;
  };

  const initObserve = () => {
    if (started.value) {
      return;
    }
    started.value = true;
    window.addEventListener("online", onlineHandler);
    window.addEventListener("offline", offlineHandler);
  };

  return {
    online,
    initObserve,
  };
});
